import { ButtonBase, type ButtonBaseProps } from './ButtonBase';
import { cn } from '../utils';

export const sectionActionButtonProps = {
	appearance: 'outline',
	intent: 'neutralLight',
	className:
		'size-7 rounded-lg border-gray-200 bg-white p-0 text-gray-400 shadow-none hover:border-primary-200 hover:bg-white hover:text-primary-600',
	iconClassName: 'size-[13px]'
} satisfies Partial<ButtonBaseProps>;

interface SectionActionButtonProps extends Omit<ButtonBaseProps, 'className'> {
	className?: string;
}

export function SectionActionButton({ className, iconClassName, ...props }: SectionActionButtonProps) {
	return (
		<ButtonBase
			{...sectionActionButtonProps}
			{...props}
			className={cn(sectionActionButtonProps.className, className)}
			iconClassName={cn(sectionActionButtonProps.iconClassName, iconClassName)}
		/>
	);
}
